import { useEffect, useState } from "react";

import Button from "@mui/material/Button";

import NextIcon from "@mui/icons-material/ArrowForward";

import { IOccupant } from "../../types/ILocation";
import Occupant from "./components/Occupant";
import OccupantSchema from "../../panels/addLocationPanel/schemas/OccupantSchema";

const Occupants = ({
  occupants,
  setOccupants,
  addOccupant,
  disabled,
  uom,
}: {
  occupants: IOccupant[];
  setOccupants: (occupants: IOccupant[]) => void;
  addOccupant?: () => void;
  disabled?: boolean;
  uom: string;
}) => {
  // const [occupant, setOccupant] = useState(blankOccupant);

  // ################################################################################################################################
  // ## VALIDATION ##################################################################################################################
  // ################################################################################################################################
  const [isValid, setIsValid] = useState(false);
  useEffect(() => {
    let newIsValid = true;

    occupants.forEach((occupant) => {
      const valid = OccupantSchema.isValidSync(occupant);

      if (!valid) {
        newIsValid = false;
      }
    });
    setIsValid(newIsValid);
  }, [occupants]);

  // expand/collapse is view-only state, keyed by occupant id, not persisted on the occupant data
  const [openOccupantIds, setOpenOccupantIds] = useState<
    Record<string, boolean>
  >({});
  const isOccupantOpen = (occupant: IOccupant) =>
    openOccupantIds[occupant.id] ?? true;

  const nextOccupant = async () => {
    if (!addOccupant) return;
    if (!isValid) return;
    try {
      setOpenOccupantIds(
        occupants.reduce(
          (acc, o) => ({ ...acc, [o.id]: false }),
          {} as Record<string, boolean>,
        ),
      );
      addOccupant();
    } catch (err) {
      console.error(err);
    }
  };

  const deleteOccupant = (index: number) => {
    const newOccupants = [...occupants];
    newOccupants.splice(index, 1);
    setOccupants(newOccupants);
  };

  return (
    <fieldset
      disabled={disabled}
      style={{
        display: "flex",
        flexDirection: "column",
        border: "3px solid #148dd3",
        borderRadius: 4,
        opacity: disabled ? "50%" : undefined,
        padding: 0,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          height: 43,
          minHeight: 43,
          paddingLeft: 26,
          paddingRight: 26,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          style={{
            color: "#0076BB",
            fontSize: 12,
            fontWeight: 700,
            textTransform: "uppercase",
          }}
        >
          Occupants
        </div>
      </div>

      {/* BODY */}
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          gap: 6,
          backgroundColor: "white",
        }}
      >
        {occupants.map((occupant, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={`Occupant-${index}`}>
            <Occupant
              // eslint-disable-next-line react/no-array-index-key
              index={index}
              occupant={occupant}
              setOccupant={(o: IOccupant) => {
                const newOccupants = [...occupants];
                newOccupants[index] = { ...o };
                setOccupants(newOccupants);
              }}
              deleteOccupant={deleteOccupant}
              uom={uom}
              isOpen={isOccupantOpen(occupant)}
              onToggleOpen={() =>
                setOpenOccupantIds((prev) => ({
                  ...prev,
                  [occupant.id]: !isOccupantOpen(occupant),
                }))
              }
            />
          </div>
        ))}

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: 10,
          }}
        >
          <Button
            id="nextOccupantButton"
            variant="contained"
            style={{ display: "flex", gap: 6, height: 34 }}
            onClick={nextOccupant}
            disabled={!isValid}
          >
            <NextIcon style={{ fontSize: 22 }} />
            NEXT OCCUPANT
          </Button>
        </div>
      </div>
      {/* END BODY */}
    </fieldset>
  );
};

export default Occupants;
